import React from 'react';
import { i18n } from 'config/locales';

import {
  CommonOnUpdate, CommonOnError, CommonScrollIntoView, CommonRequired
} from 'types/props';
import ValidationElement, {
  ValidationElementProps,
} from 'components/Form/ValidationElement/ValidationElement';
import { TelephoneItemModel } from 'forms/shared/types';
import { AccordionItemProps } from 'components/Form/Accordion/types';
import Field from 'components/Form/Field';
import Telephone from './Telephone';

/*
 This component was designed to be functionally similar to AdditionalActivity,
 See that component if this one appears broke to determine what action to take.
*/

interface Props extends ValidationElementProps {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  className?: string
  scrollIntoView?: CommonScrollIntoView
  required?: CommonRequired
  attribute?: string
  telephoneFieldTitle?: string
  formType?: string
  showTimeOfDay?: boolean,
  timeOfDayLabel?: string,
  allowNotApplicable?: boolean,
}

interface ItemProps
  extends Props,
  Partial<TelephoneItemModel>,
    Omit<AccordionItemProps, 'name'> {}

export default class TelephoneCollectionItem extends ValidationElement<ItemProps> {
  update = (queue: Partial<TelephoneItemModel>) => {
    this.props.onUpdate({
      Has: this.props.Has,
      Telephone: this.props.Telephone,
      ...queue,
    });
  };

  onUpdateTelephone = (values: Partial<TelephoneItemModel['Telephone']>) => {
    this.update({ Telephone: values });
  };

  render() {
    const attribute = `${this.props.attribute}.items[${this.props.$index}].Item`;

    return (
      <Field
        optional
        scrollIntoView={this.props.scrollIntoView}
        className="minimal-margin-bottom"
        title={this.props.telephoneFieldTitle}
        attribute={`${attribute}.Telephone`}
        exactAttribute
      >
        <Telephone
          attribute={`${attribute}.Telephone`}
          name="Telephone"
          bind
          required={this.props.required}
          onUpdate={this.onUpdateTelephone}
          onError={this.props.onError}
          typeClass="title"
          showNumberType
          showTimeOfDay={this.props.showTimeOfDay}
          timeOfDayLabel={this.props.timeOfDayLabel}
          allowNotApplicable={this.props.allowNotApplicable}
          {...this.props.Telephone}
        />
      </Field>
    );
  }
}

TelephoneCollectionItem.defaultProps = {
  onUpdate: (queue) => {},
  onError: (value, arr) => arr,
  telephoneFieldTitle: 'What is the telephone?',
  showTimeOfDay: false,
  timeOfDayLabel: '',
  allowNotApplicable: false,
  formType: '',
  Telephone: {},
  Has: {},
};
